import * as types from '../constants/coreConstants';
import * as api from '../../api/api';
import {logout} from '../../auth/actions/authActions';


export function beginAjaxCall(httpMethod) {
	return {
		type: types.BEGIN_AJAX_CALL,
		response: httpMethod
	};
}

export function endAjaxCall(httpMethod) {
	return {
		type: types.END_AJAX_CALL,
		response: httpMethod
	};
}


export function getContactNumberSuccess(contactNumber) {
	return {
		type: types.GET_CONTACT_INFO_SUCCCESS,
		response: contactNumber
	};
}

export function getMerchantInfoSuccess(merchantInfo) {
	return {
		type: types.GET_MERCHANT_INFO_SUCCCESS,
		response: merchantInfo
	};
}

export function getContactNumber(clientId, jobTypeId = 0) {
	return function (dispatch) {
		api.get(`booking/contact/${clientId}/${jobTypeId}`, true, true)
			.then(function (response) {
				dispatch(getContactNumberSuccess(response));
			}).catch(function () {
				// dispatch(notFound());
				//browserHistory.push('/contactus/error/'.concat(jobId));
			});
	};
}

export function getFeatures(clientId) {
	return function(dispatch) {
		dispatch({ type: types.GET_FEATURES });
		
		api.get(`masterdata/features/${clientId}`, true, true).then(response => {
			dispatch(getFeaturesSuccess(response));
		}).catch(() => {});
	}
}

export function getFeaturesSuccess(response) {
	return {
		type: types.GET_FEATURES_SUCCESS,
		response: response
	};
}

export function getMerchantInfo(clientId, merchantId) {

	return function (dispatch) {
		api.get(`profile/client/${clientId}/merchant/${merchantId}`, false, true)
			.then(function (response) {

				if (response)
					dispatch(getMerchantInfoSuccess(response));
				else
					dispatch(getMerchantInfoSuccess({}));

			}).catch(function () {
				dispatch(logout());
			});
	};
}


// WEBPACK FOOTER //
// ./app/core/actions/coreActions.js